import { PICKABLE_INVOICE_CATEGORIES } from "~/constants/all";
import type { InvoiceCategories } from "~/types";

const getCategoryLabel = (category: InvoiceCategories) => {
  const itemsToPickFrom = [...PICKABLE_INVOICE_CATEGORIES];
  // Added after the fact so that the security deposit category isnt listed in the dropdown.
  itemsToPickFrom.push({
    label: "Security Deposit",
    value: "security-deposit",
  });

  return itemsToPickFrom.find((c) => c.value === category)?.label;
};

export default getCategoryLabel;
